import * as React from 'react'
import './index.scss'
import { TitleAndDescriptionProps } from './types'

export const TitleAndDescription: React.FC<TitleAndDescriptionProps> = ({ title, description }) => {
  return (
    <div className="text-content">
      <h2 className="title">{title}</h2>
      <p className="description">{description}</p>
    </div>
  )
}
